@if (faq) {
    @if (faq.actionUrl) {
        @if (isExternalLink(faq.actionUrl)) {
            <a [href]="faq.actionUrl" target="_blank" class="core-ai-faq">
                <p class="core-ai-faq__title" [innerText]="faq.question"></p>
                <p class="core-ai-faq__body" [innerHtml]="faq.answer"></p>
                <span class="core-ai-faq__icon">
                    <core-icon name="icon-arrow-right" color="var(--color-primary)"></core-icon>
                </span>
            </a>
        } @else {
            <a [routerLink]="faq.actionUrl" class="core-ai-faq">
                <p class="core-ai-faq__title" [innerText]="faq.question"></p>
                <p class="core-ai-faq__body" [innerHtml]="faq.answer"></p>
                <span class="core-ai-faq__icon">
                    <core-icon name="icon-arrow-right" color="var(--color-primary)"></core-icon>
                </span>
            </a>
        }
    } @else {
        <div class="core-ai-faq">
            <p class="core-ai-faq__title" [innerText]="faq.question"></p>
            <p class="core-ai-faq__body" [innerHtml]="faq.answer"></p>
            <span class="core-ai-faq__icon">
                <core-icon name="icon-arrow-right" color="var(--color-primary)"></core-icon>
            </span>
        </div>
    }
}
